const doc = [({"ko":({"constantBookingOptionStatus":({"arranged":"예약 된", "cancelled":"취소 된"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;